import { haoClient } from './clients';

/**
 * 取得鉅亨號熱門貼文
 *
 * API: https://hao.cnyes.com/h_api/1/wall
 * 參數: RAW 格式 { p1: "", p2: "2", timezoneOffset: "", session: "" }
 * p2 為分類，2 為推薦
 *
 */
export const PostAnueHaoHotPosts = (type = 2) => {
  const params = { p1: '', p2: type, timezoneOffset: '', session: '' };
  const url = '/ho_api/1/wall';

  return haoClient.post(url, params);
};

/**
 * 取得鉅亨號分類文章
 * @param category 台股, 外匯, 商品期貨, ...
 */
export const POSTAnueHaoCategoryPosts = (category: string) => {
  const params = {
    分類: category,
    安全密碼: 'cnyeshao@20210914'
  };
  const url = `/ho_api/1/list_article_bycategory_20`;

  return haoClient.post(url, params);
};

/**
 * 取得討論區 like and comment count
 * @param id 新聞 id
 */

type GETCommentCountResponse = {
  items: {
    like: number;
    reply: number;
  };
  status: number;
  message: string;
};

export const GETCommentCount = async (newsId: number): Promise<GETCommentCountResponse> => {
  const url = `/ho_api/1/stp/news/${newsId}/reaction`;
  const params = {};

  try {
    const data = await haoClient.get(url, params);
    if (data.statusCode === 500) {
      throw new Error(`error:${data.error.message}`);
    }
    return data;
  } catch (error) {
    console.error('[API Error GETCommentCount]:', error);
    return {
      items: {
        like: 0,
        reply: 0
      },
      status: 500,
      message: 'error'
    };
  }
};
